"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var merge_1 = __importDefault(require("lodash/merge"));
var isEmpty_1 = __importDefault(require("lodash/isEmpty"));
var NextConfigProvider_1 = __importDefault(require("../NextConfigProvider"));
var cn_next_1 = __importDefault(require("../../locale/cn-next"));
var LocaleContext_1 = __importDefault(require("../../context/LocaleContext"));
var withI18n_1 = __importDefault(require("../../hoc/withI18n"));
var i18n_1 = __importStar(require("../../i18n/i18n"));
var services_1 = require("../../services");
var InPandaConfigProvider = function (_a) {
    var children = _a.children, locale = _a.locale, lang = _a.lang, props = __rest(_a, ["children", "locale", "lang"]);
    var context = (0, react_1.useContext)(LocaleContext_1.default);
    // 如果上下文中有翻译，将进行合并
    var localeExtContext = (0, react_1.useMemo)(function () {
        return (0, isEmpty_1.default)(context.locale) ? locale : (0, merge_1.default)({}, context.locale, locale);
    }, [locale, context.locale]);
    var langExtContext = lang || context.lang;
    // 如果上下文中有语种，则使用上下文中的语种
    var _b = (0, react_1.useState)(langExtContext || i18n_1.default.getLang()), currentLang = _b[0], setCurrentLang = _b[1];
    var currentLocale = (0, react_1.useMemo)(function () {
        var theLocale = (0, merge_1.default)({}, cn_next_1.default, localeExtContext);
        // 额外使用语言包
        if (window._PANDA_EXUI && window._PANDA_EXUI[currentLang]) {
            return window._PANDA_EXUI[currentLang];
        }
        // 如果不存在该语种 使用英文
        return (0, merge_1.default)({}, theLocale["en-US"], theLocale[currentLang]);
    }, [currentLang, localeExtContext]);
    // 该$i18n作为configProvider包裹的$i18n实例，有别于cdn实例
    var _$i18n = (0, react_1.useMemo)(function () { return (0, i18n_1.init)({ locale: localeExtContext, lang: langExtContext }); }, [langExtContext, localeExtContext]);
    var eventHanderId = (0, react_1.useRef)("");
    (0, react_1.useEffect)(function () {
        eventHanderId.current = services_1.pandaEvent.on("CHANGE_LANG", function (changedLang) {
            if (!langExtContext) {
                setCurrentLang(changedLang);
            }
        });
        return function () { return services_1.pandaEvent.off(eventHanderId.current); };
    }, [langExtContext]);
    var providerValue = (0, react_1.useMemo)(function () { return ({
        locale: localeExtContext,
        lang: langExtContext,
        _lang: currentLang,
        $i18n: _$i18n,
    }); }, [localeExtContext, langExtContext, _$i18n, currentLang]);
    return (react_1.default.createElement(NextConfigProvider_1.default, __assign({}, props, { locale: currentLocale }),
        react_1.default.createElement(LocaleContext_1.default.Provider, { value: providerValue }, children)));
};
var PandaConfigProvider = InPandaConfigProvider;
PandaConfigProvider.config = withI18n_1.default;
exports.default = PandaConfigProvider;
